import { alpha } from '@mui/material/styles';

export const resetPasswordModalStyles = {
  dialog: (theme) => ({
    '& .MuiDialog-container': {
      '& .MuiDialog-paper': {
        margin: theme.spacing(2),
        borderRadius: theme.spacing(3),
        overflow: 'hidden',
      },
    },
  }),

  paper: (theme) => ({
    borderRadius: theme.spacing(3),
    boxShadow: theme.palette.mode === 'dark'
      ? '0 24px 48px rgba(0, 0, 0, 0.4), 0 8px 16px rgba(0, 0, 0, 0.3)'
      : '0 24px 48px rgba(0, 0, 0, 0.12), 0 8px 16px rgba(0, 0, 0, 0.08)',
    border: theme.palette.mode === 'dark' 
      ? `1px solid ${alpha(theme.palette.common.white, 0.1)}`
      : `1px solid ${alpha(theme.palette.common.black, 0.05)}`,
  }),

  header: (theme) => ({
    background: theme.palette.mode === 'dark'
      ? `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.15)} 0%, ${alpha(theme.palette.secondary.main, 0.15)} 100%)`
      : `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.1)} 0%, ${alpha(theme.palette.secondary.light, 0.1)} 100%)`,
    padding: theme.spacing(3, 3, 2.5, 3),
    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
  }),

  iconContainer: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 64,
    height: 64,
    borderRadius: '50%',
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
    marginBottom: theme.spacing(2),
    boxShadow: theme.palette.mode === 'dark'
      ? '0 8px 20px rgba(99, 102, 241, 0.3)'
      : '0 8px 20px rgba(99, 102, 241, 0.2)',
  }),

  title: (theme) => ({
    fontWeight: 700,
    fontSize: '1.5rem',
    letterSpacing: '-0.02em',
    marginBottom: theme.spacing(0.5),
  }),

  description: {
    color: 'text.secondary',
    fontSize: '0.95rem',
    lineHeight: 1.6,
  },

  content: (theme) => ({
    padding: theme.spacing(4, 3),
    '&.MuiDialogContent-root': {
      paddingTop: theme.spacing(4),
    },
  }),

  successContainer: (theme) => ({
    textAlign: 'center',
    padding: theme.spacing(2, 0),
  }),

  successIconContainer: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 80,
    height: 80,
    borderRadius: '50%',
    background: `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0.1)} 0%, ${alpha(theme.palette.success.light, 0.1)} 100%)`,
    margin: '0 auto',
    marginBottom: theme.spacing(3),
  }),

  successTitle: (theme) => ({
    fontWeight: 600,
    fontSize: '1.25rem',
    marginBottom: theme.spacing(1),
  }),

  successMessage: (theme) => ({
    color: 'text.secondary',
    fontSize: '0.95rem',
    lineHeight: 1.6,
    marginBottom: theme.spacing(2),
  }),

  formContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  }),

  textField: (theme) => ({
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(1.5),
      fontSize: '0.95rem',
      '&:hover fieldset': {
        borderColor: 'primary.main',
      },
      '&.Mui-focused fieldset': {
        borderWidth: 2,
      },
    },
  }),

  actions: (theme) => ({
    padding: theme.spacing(3),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
    gap: theme.spacing(1.5),
    display: 'flex',
    justifyContent: 'flex-end',
  }),

  button: (theme) => ({
    borderRadius: theme.spacing(1.5),
    fontSize: '0.95rem',
    fontWeight: 600,
    textTransform: 'none',
    padding: theme.spacing(1.25, 2.5),
    minWidth: 120,
  }),

  submitButton: (theme) => ({
    borderRadius: theme.spacing(1.5),
    fontSize: '0.95rem',
    fontWeight: 600,
    textTransform: 'none',
    padding: theme.spacing(1.25, 3),
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
    },
  }),
};

